import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            实时更新的热门爆料排行，看看今天大家都在追什么瓜
          </p>

          <div className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className={`flex items-center gap-4 px-5 py-4 transition-colors duration-200 cursor-pointer no-underline hover:bg-background-100/70 ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 text-sm font-heading ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-primary-300 text-background-50' :
                  item.rank === 3 ? 'bg-primary-200 text-primary-700' :
                  'bg-secondary-100 text-secondary-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800 truncate hover:text-primary-500 transition-colors duration-200">
                    {item.title}
                  </div>
                </div>

                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                  <span className={`text-[11px] whitespace-nowrap ${
                    item.trend === 'up' ? 'text-primary-500' : 'text-secondary-500'
                  }`}>
                    {item.change}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}